// src/utils/postTicket.js — add a ticket, asking first when that person already has one for the event
// [marker: fixes-oct21 v1]
import api from './api';

export class SkippedDuplicate extends Error {}

export default async function postTicket(eventId, payload) {
  try {
    return await api.post(`/events/${eventId}/tickets`, payload);
  } catch (err) {
    if (err.response?.status === 409 && err.response?.data?.code === 'DUPLICATE_TICKET') {
      if (window.confirm(`${err.response.data.error}\n\nAdd another ticket for them anyway?`)) {
        return api.post(`/events/${eventId}/tickets`, { ...payload, allowDuplicate: true });
      }
      throw new SkippedDuplicate('skipped');
    }
    throw err;
  }
}
